import React, { useEffect, useState } from "react";
import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaMobileAlt,
  FaGlobe,
} from "react-icons/fa";
import Navbar from "../nav_bar/Navbar";
import Footer from "../footer/Footer";
import { fetchPublicSocialMedia } from "./socialMediaService";
import "./socialMedia.css";

const ICON_MAP = {
  WHATSAPP_MOBILE: { icon: FaWhatsapp, color: "#25D366" },
  WHATSAPP_CHANNEL: { icon: FaWhatsapp, color: "#075E54" },
  WHATSAPP_GROUP: { icon: FaWhatsapp, color: "#25D366" },
  FACEBOOK: { icon: FaFacebookF, color: "#1877F2" },
  INSTAGRAM: { icon: FaInstagram, color: "#E4405F" },
  LINKEDIN: { icon: FaLinkedinIn, color: "#0A66C2" },
  YOUTUBE: { icon: FaYoutube, color: "#FF0000" },
  MOBILE_APP: { icon: FaMobileAlt, color: "#34A853" },
  WEBSITE: { icon: FaGlobe, color: "#028891" },
};

const getLink = (entry) => {
  if (entry.type === "WHATSAPP_MOBILE") {
    const number = entry.link.replace(/[^0-9]/g, "");
    return `https://wa.me/${number}`;
  }
  return entry.link;
};

const HIDDEN_ON_WEB = ["WEBSITE"];

const SocialMediaPage = () => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPublicSocialMedia().then((res) => {
      if (res.success) {
        setEntries(res.data.filter((e) => !HIDDEN_ON_WEB.includes(e.type)));
      }
      setLoading(false);
    });
  }, []);

  if (loading) return (
    <>
      <Navbar />
      <div style={{ marginTop: "80px", textAlign: "center", padding: "40px" }}>Loading...</div>
      <Footer />
    </>
  );

  return (
    <>
    <Navbar />
    <div className="social-media-page" style={{ marginTop: "80px" }}>
      <h2 className="social-media-title">Connect With Us</h2>
      <div className="social-media-grid">
        {entries.map((entry) => {
          const config = ICON_MAP[entry.type] || { icon: FaGlobe, color: "#555" };
          const Icon = config.icon;
          return (
            <a
              key={entry.id}
              href={getLink(entry)}
              target="_blank"
              rel="noopener noreferrer"
              className="social-media-card"
              style={{ borderColor: config.color }}
            >
              <div className="social-media-icon" style={{ backgroundColor: config.color }}>
                <Icon size={22} color="#fff" />
              </div>
              <span className="social-media-name">{entry.name}</span>
            </a>
          );
        })}
      </div>
    </div>
    <Footer />
    </>
  );
};

export default SocialMediaPage;
